import { ChartCandlestick, Gauge, Wallet, Zap } from 'lucide-react';
import React from 'react';

import { Button } from '@/components/ui/button';
import { SnailGlyph } from '@/components/ui/SnailGlyph';

interface WelcomeStepProps {
    onNext: () => void;
}

const FEATURES: {
    icon: React.ComponentType<{ size?: number; className?: string }>;
    title: string;
    description: string;
}[] = [
    {
        icon: Zap,
        title: 'One-tap speed trades',
        description:
            'Open and close leveraged positions in seconds, no gas, no signing per trade.',
    },
    {
        icon: ChartCandlestick,
        title: '230+ live markets',
        description:
            'BTC, ETH and alts, plus stocks & gold, powered by Hyperliquid.',
    },
    {
        icon: Gauge,
        title: 'Leverage up to 40×',
        description: 'Per-market caps with deep liquidity behind every fill.',
    },
    {
        icon: Wallet,
        title: 'Gasless Snappy Wallet',
        description:
            'Deposit USDC once, withdraw back to your own wallet any time.',
    },
];

/** Step 1 — brand welcome card with the product highlights. */
const WelcomeStep: React.FC<WelcomeStepProps> = ({ onNext }) => (
    <div className="flex flex-col items-center px-6 pb-6 pt-2 text-center">
        <div className="flex size-16 items-center justify-center rounded-2xl border border-border bg-secondary/50">
            <SnailGlyph size={34} className="text-primary" />
        </div>

        <h2 className="mt-4 text-2xl font-bold tracking-tight text-foreground">
            Welcome to Snappy Trade
        </h2>
        <p className="mt-1 text-sm text-muted-foreground">
            Everything you need to speed-trade, in one place.
        </p>

        <div className="mt-6 w-full divide-y divide-border rounded-xl border border-border text-left">
            {FEATURES.map(({ icon: Icon, title, description }) => (
                <div key={title} className="flex items-center gap-3 p-3.5">
                    <div className="flex size-10 shrink-0 items-center justify-center rounded-lg border border-border bg-secondary/40">
                        <Icon size={18} className="text-foreground/80" />
                    </div>
                    <div className="min-w-0">
                        <p className="text-sm font-semibold text-foreground">
                            {title}
                        </p>
                        <p className="text-xs leading-relaxed text-muted-foreground">
                            {description}
                        </p>
                    </div>
                </div>
            ))}
        </div>

        <Button size="lg" className="mt-6 w-full font-semibold" onClick={onNext}>
            Get started
        </Button>
    </div>
);

export default WelcomeStep;
